import React from 'react';

import {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  paragraph1,
  paragraph2,
  paragraphDefault,
  small,
} from './TypographyStyles';

type TypographyProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
  variant?: string;
  maxWidth?: string;
  position?: string;
  $size?: string;
};

const Typography = ({ children, className, id, variant, ...props }: TypographyProps) => {
  let Component;

  switch (variant) {
    case 'h1':
      Component = h1;
      break;
    case 'h2':
      Component = h2;
      break;
    case 'h3':
      Component = h3;
      break;
    case 'h4':
      Component = h4;
      break;
    case 'h5':
      Component = h5;
      break;
    case 'h6':
      Component = h6;
      break;
    case 'paragraph1':
      Component = paragraph1;
      break;
    case 'paragraph2':
      Component = paragraph2;
      break;
    case 'small':
      Component = small;
      break;
    default:
      Component = paragraphDefault;
  }

  return (
    <Component className={className} id={id} {...props}>
      {children}
    </Component>
  );
};

export default Typography;
